import { Pipe, PipeTransform } from '@angular/core';
import { ITraveller } from "libraries/service/resources/booking/interfaces/IGetBookings";
import { EIdentityInfoType } from "libraries/component/identity-info-editor/identity-info-editor.interface";

@Pipe({
  name: 'getIdentityInfoDisplayMode'
})
export class GetIdentityInfoDisplayModePipe implements PipeTransform {

  public transform(traveller: ITraveller): EIdentityInfoType {
    if (!traveller) {
      return null;
    }

    if (traveller.passport && traveller.passport.length) {
      return EIdentityInfoType.passport;
    }

    if (traveller.identityCard && traveller.identityCard.length) {
      return EIdentityInfoType.identityCard;
    }

    if (traveller.secureFlightPassengerData) {
      return EIdentityInfoType.secureFlightPassengerData;
    }

    return null;
  }

}
